import * as types from './types';

const INITIAL_STATE = {
    destinationInput: undefined,
    destinationPlaceId: undefined,
    originInput: undefined,
    originPlaceId: undefined,
    passengersInput: undefined,
};

const setOriginInput = (state, { payload }) => ({
    ...state,
    originInput: payload,
});

const setDestinationInput = (state, { payload }) => ({
    ...state,
    destinationInput: payload,
});

const setOriginPlaceId = (state, { payload }) => ({
    ...state,
    originPlaceId: payload,
});

const setDestinationPlaceId = (state, { payload }) => ({
    ...state,
    destinationPlaceId: payload,
});

const setPassengersInput = (state, { payload }) => ({
    ...state,
    passengersInput: payload,
});

const handlers = {
    [types.SET_DESTINATION_INPUT]: setDestinationInput,
    [types.SET_DESTINATION_PLACE_ID]: setDestinationPlaceId,
    [types.SET_ORIGIN_INPUT]: setOriginInput,
    [types.SET_ORIGIN_PLACE_ID]: setOriginPlaceId,
    [types.SET_PASSENGERS_INPUT]: setPassengersInput,
};

const reducer = (state = INITIAL_STATE, action = {}) => {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
        const handler = handlers[action.type];

        return handler(state, action);
    }

    return state;
};

export {
    INITIAL_STATE,
};

export default reducer;
